import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Hidden, Tab as MuiTab, Tabs } from '@material-ui/core'
import { useStyles } from './styles'
import { isMobile } from 'utils'

const Tab = ({ mobileonly = false, ...props }) => {
    const classes = useStyles()
    const tab = (
        <MuiTab
            classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
                wrapper: classes.tabWrapper,
            }}
            {...props}
        />
    )

    return mobileonly && !isMobile() ? <Hidden mdUp>{tab}</Hidden> : tab
}

const TabGroup = ({ value, onChange, children }) => {
    const classes = useStyles()
    const handleChange = useCallback((_, newValue) => onChange(newValue), [onChange])

    return (
        <Tabs
            classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            scrollButtons="off"
        >
            {children}
        </Tabs>
    )
}

TabGroup.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
}

export { Tab }
export default React.memo(TabGroup)
